import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addContactUsPublic } from "./ContactUsHomeAPI";
const initialState = {
    data: [],
    loading: false,
    error: null,
};
export const addContactUsPublicAsync = createAsyncThunk(
    "contactUs/add",
    async (newContactUs, { rejectWithValue }) => {
        try {
            return await addContactUsPublic(newContactUs);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


const ContactUsPublicSlice = createSlice({
    name: "contactUsPublic",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch cases


            // Add case
            .addCase(addContactUsPublicAsync.fulfilled, (state, action) => {
                state.data?.push(action.payload);
            })
            .addCase(addContactUsPublicAsync.rejected, (state, action) => {
                state.error = action.payload;
            })


    },
});

// Selector
export const selectContactUsPublic = (state) => state.contactUsPublic.data;

export default ContactUsPublicSlice.reducer;